import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { QuestionAddress } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/address";
import { QuestionGeoLocation } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/geo-location/geo-location";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { HotelSettingsHotelInfoFormModel } from "../../../../model/type";
import type { HotelSettingsHotelInfoFormModelMethodsType } from "../../../../model/usecase/use-create-form-model/methods";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];

	addressMethods: HotelSettingsHotelInfoFormModelMethodsType["addressMethods"];
	geoLocationMethods: HotelSettingsHotelInfoFormModelMethodsType["geoLocationMethods"];
	hotelSettingsHotelInfoFormModelMethods: HotelSettingsHotelInfoFormModelMethodsType["hotelSettingsHotelInfoFormModelMethods"];
};

const ACCORDION_VALUE = "hotelInfo_geoLocation";

export const HotelSettingsHotelInfoDetailedInfoSettingsIsland = ({
	viewModel,
	addressMethods,
	geoLocationMethods,
	hotelSettingsHotelInfoFormModelMethods,
}: Props) => {
	const accordionDefaultValue =
		(geoLocationMethods.geoLocation?.lat ?? geoLocationMethods.geoLocation?.lon) ? ACCORDION_VALUE : undefined;

	return (
		<FeatureIslandMainWithBackGround islandTitle="詳細情報設定">
			<QuestionForMain
				required={true}
				title="連絡先メールアドレス"
				guide="お客様に表示されるメールアドレスです。<br /> そのほかにもCHILLNNからのお知らせメールが届きます。"
				inputChildren={
					<InputTextField
						value={viewModel.email?.value}
						errorMessage={viewModel.email?.error}
						handleChange={hotelSettingsHotelInfoFormModelMethods.onSetEmailAddress}
					/>
				}
			/>
			<QuestionForMain
				required={true}
				guide="お客様に表示される電話番号です。電話番号が存在しない場合は自由な文字列を入力できます。"
				title="電話番号"
				inputChildren={
					<InputTextField
						value={viewModel.tel?.value}
						errorMessage={viewModel.tel?.error}
						handleChange={hotelSettingsHotelInfoFormModelMethods.onSetTel}
					/>
				}
			/>
			<QuestionAddress
				hasFeatureIslandCategoryContext={false}
				required={true}
				title="施設の住所"
				guide=""
				isEdited={addressMethods.isEdited}
				hasError={addressMethods.hasError}
				address={addressMethods.address}
				onSetPref={addressMethods.onSetPref}
				onSetCity={addressMethods.onSetCity}
				onSetTown={addressMethods.onSetTown}
				onSetPostalCode={addressMethods.onSetPostalCode}
			/>
			<Accordion type="single" defaultValue={accordionDefaultValue} collapsible>
				<AccordionItem value={ACCORDION_VALUE}>
					<AccordionTrigger>より詳細な住所を入力する</AccordionTrigger>
					<AccordionContent>
						<div className="pb-10 pt-4">
							<QuestionGeoLocation
								hasFeatureIslandCategoryContext={false}
								title="緯度・経度"
								guide="詳細なマップを表示したい場合は、ここに緯度、経度を入力してください。<br />マップ表示の際に住所よりも優先されます。"
								isEdited={geoLocationMethods.isEdited}
								hasError={geoLocationMethods.hasError}
								geoLocation={geoLocationMethods.geoLocation}
								onSetLatitude={geoLocationMethods.onSetLatitude}
								onSetLongitude={geoLocationMethods.onSetLongitude}
							/>
						</div>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</FeatureIslandMainWithBackGround>
	);
};

HotelSettingsHotelInfoDetailedInfoSettingsIsland.displayName = "HotelSettingsHotelInfoDetailedInfoSettingsIsland";
